var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { BButton, BFormCheckbox, BModal, BPagination, BTable } from "bootstrap-vue";
import { computed, ref, watch } from "vue";
import localize from "@/utils/localization";
import { bytesToString } from "@/utils/utils";
import { PaginationOptions } from "./model";
import UtcDate from "@/components/UtcDate.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ReviewCleanupDialog',
    props: {
        operation: { default: undefined },
        totalItems: { default: 0 },
        modalStatic: { type: Boolean }
    },
    emits: ["onConfirmCleanupSelectedItems"],
    setup(__props, { expose, emit }) {
        const props = __props;
        const permanentlyDeleteText = localize("Permanently delete");
        const captionText = localize("To free up account space, review and select items to be permanently deleted here.");
        const agreementText = localize("I understand that once I delete the items, they cannot be recovered.");
        const fields = [
            {
                key: "selected",
                label: "",
                sortable: false,
            },
            {
                key: "name",
                sortable: true,
            },
            {
                key: "size",
                sortable: true,
                formatter: toNiceSize,
            },
            {
                label: "Updated",
                key: "update_time",
                sortable: true,
            },
        ];
        const MAXIMUM_ITEMS_PER_PAGE = 25;
        const sortBy = ref("size");
        const sortDesc = ref(true);
        const currentPage = ref(1);
        const totalRows = ref(1);
        const allSelected = ref(false);
        const indeterminate = ref(false);
        const showDialog = ref(false);
        const items = ref([]);
        const selectedItems = ref([]);
        const confirmChecked = ref(false);
        const isBusy = ref(false);
        const selectedItemCount = computed(() => {
            return selectedItems.value.length;
        });
        const hasItemsSelected = computed(() => {
            return selectedItemCount.value > 0;
        });
        const hasPages = computed(() => {
            return totalRows.value > MAXIMUM_ITEMS_PER_PAGE;
        });
        const title = computed(() => {
            var _a, _b;
            return (_b = (_a = props.operation) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "";
        });
        const confirmationTitle = computed(() => {
            return `Permanently delete ${selectedItemCount.value} items?`;
        });
        const deleteButtonVariant = computed(() => {
            return hasItemsSelected.value ? "danger" : "";
        });
        const deleteItemsText = computed(() => {
            return hasItemsSelected.value ? `${selectedItemCount.value} items` : "";
        });
        const confirmButtonVariant = computed(() => {
            return confirmChecked.value ? "danger" : "";
        });
        watch(props, (newVal) => {
            currentPage.value = 1;
            totalRows.value = newVal.totalItems;
        });
        watch(selectedItems, (newVal) => {
            if (newVal.length === 0) {
                indeterminate.value = false;
                allSelected.value = false;
            }
            else if (newVal.length === totalRows.value) {
                indeterminate.value = false;
                allSelected.value = true;
            }
            else {
                indeterminate.value = true;
                allSelected.value = false;
            }
        });
        function toNiceSize(sizeInBytes) {
            return bytesToString(sizeInBytes, true, undefined);
        }
        function toggleSelectAll(checked) {
            return __awaiter(this, void 0, void 0, function* () {
                if (checked) {
                    yield selectAllItems();
                }
                else {
                    unselectAllItems();
                }
            });
        }
        function openModal() {
            showDialog.value = true;
        }
        function hideModal() {
            showDialog.value = false;
        }
        function onShowModal() {
            resetModal();
        }
        function resetModal() {
            unselectAllItems();
        }
        function resetConfirmationModal() {
            confirmChecked.value = false;
        }
        function onConfirmCleanupSelectedItems() {
            emit("onConfirmCleanupSelectedItems", selectedItems.value);
            hideModal();
        }
        function onSort(props) {
            sortBy.value = props.sortBy;
            sortDesc.value = props.sortDesc;
        }
        function itemsProvider(ctx) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const page = ctx.currentPage > 0 ? ctx.currentPage - 1 : 0;
                    const offset = page * ctx.perPage;
                    const options = new PaginationOptions({
                        offset: offset,
                        limit: ctx.perPage,
                        sortBy: sortBy.value,
                        sortDesc: sortDesc.value,
                    });
                    const result = yield props.operation.fetchItems(options);
                    return result;
                }
                catch (error) {
                    return [];
                }
            });
        }
        function selectAllItems() {
            return __awaiter(this, void 0, void 0, function* () {
                isBusy.value = true;
                const allItems = yield props.operation.fetchItems(new PaginationOptions({
                    offset: 0,
                    limit: totalRows.value,
                    sortBy: sortBy.value,
                    sortDesc: sortDesc.value,
                }));
                items.value = allItems;
                selectedItems.value = allItems;
                isBusy.value = false;
            });
        }
        function unselectAllItems() {
            selectedItems.value = [];
        }
        expose({
            openModal,
            selectedItems,
        });
        return { __sfc: true, props, emit, permanentlyDeleteText, captionText, agreementText, fields, MAXIMUM_ITEMS_PER_PAGE, sortBy, sortDesc, currentPage, totalRows, allSelected, indeterminate, showDialog, items, selectedItems, confirmChecked, isBusy, selectedItemCount, hasItemsSelected, hasPages, title, confirmationTitle, deleteButtonVariant, deleteItemsText, confirmButtonVariant, toNiceSize, toggleSelectAll, openModal, hideModal, onShowModal, resetModal, resetConfirmationModal, onConfirmCleanupSelectedItems, onSort, itemsProvider, selectAllItems, unselectAllItems, BButton, BFormCheckbox, BModal, BPagination, BTable, UtcDate };
    }
});
